<template>
    <div>
        <kgr-duplication-selection
            v-model="selection"
            label-prefix="parent_user_status"
            :filter-options="filterOptions"
            :kindergartens="kindergartens"
            class="kgr-row"
            @kindergartenSourceChanged="getParentUserForKindergartenSource"
            @kindergartenTargetChanged="getParentUserForKindergartenTarget"
        />

        <kgr-loading v-if="showLoading" />

        <kgr-empty-data
            v-else-if="selection.kindergartenSource === null"
            :value="$t('duplication.parent_user.empty_data.no_kindergarten')"
        />
        <kgr-empty-data
            v-else-if="selection.kindergartenSource !== null && sourceParentUser.length === 0"
            :value="$t('duplication.parent_user.empty_data.filter')"
        />

        <kgr-duplication
            v-else-if="sourceParentUser.length > 0"
            :source-elements="sourceParentUser"
            :target-elements="targetParentUsers"
            :kindergarten-source="selection.kindergartenSource"
            :kindergarten-target="selection.kindergartenTarget"
            :filters="selection.filters"
            :in-progress="inProgress"
            :matching-function="(filters, element) => element.statuses.some(status => filters.indexOf(status) !== -1)"
            type="parent_user"
            @duplicate="duplicate($event)"
        >
            <template #header>
                <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--noGrow column_status">
                    {{ $t('Status') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--noGrow">
                    {{ $t('Vorname') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Nachname') }}
                </th>
            </template>
            <template #row="scope">
                <td
                    style="white-space: nowrap"
                    class="kgr-table__cell kgr-table__cell--noGrow"
                >
                    <kgr-parent-user-status-icon
                        v-for="(status, index) in scope.element.statuses"
                        :key="index"
                        small
                        :status="status"
                        :title="$t(`parent_user_status.${status}`)"
                        style="display: inline-flex"
                    />
                </td>
                <td class="kgr-table__cell kgr-table__cell--noGrow">
                    {{ scope.element.firstName }}
                </td>
                <td class="kgr-table__cell kgr-table__cell--noGrow">
                    {{ scope.element.lastName }}
                </td>
            </template>
        </kgr-duplication>
    </div>
</template>

<script>
import Duplication from './Duplication';
import DuplicationSelection from './DuplicationSelection';
import EmptyData from '../common/EmptyData.vue';
import Loading from '../common/Loading.vue';
import ParentUserDuplicationRepository from '../../js/repository/ParentUserDuplicationRepository';
import ParentUserRepository from '../../js/repository/ParentUserRepository';
import ParentUserStatusIcon from '../parent-user/ParentUserStatusIcon.vue';

export default {
    components: {
        'kgr-duplication-selection': DuplicationSelection,
        'kgr-duplication': Duplication,
        'kgr-parent-user-status-icon': ParentUserStatusIcon,
        'kgr-empty-data': EmptyData,
        'kgr-loading': Loading,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
        kindergartens: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selection: {
                filters: ['archived', 'active', 'waiting_for_contract_start', 'waiting_for_contract_signing', 'on_waiting_list', 'signed_up', 'created', 'without_children'],
                kindergartenSource: null,
                kindergartenTarget: null,
            },
            filterOptions: ['archived', 'active', 'waiting_for_contract_start', 'waiting_for_contract_signing', 'on_waiting_list', 'signed_up', 'created', 'without_children'],
            inProgress: false,
            matchingFunction: (filters, element) => {
                element.statuses.forEach((status) => {
                    if (filters.indexOf(status) !== -1) {
                        return true;
                    }
                });

                return false;
            },
            sourceParentUser: [],
            targetParentUsers: [],
            showLoading: false,
        };
    },
    methods: {
        duplicate(elements) {
            this.inProgress = true;
            ParentUserDuplicationRepository.duplicate(elements.map((element) => element.id), this.selection.kindergartenTarget.id)
                .then(() => {
                    this.inProgress = false;
                    this.$notify.success('duplication.parent_user.success');
                    this.getParentUserForKindergartenTarget(this.selection.kindergartenTarget);
                })
                .catch(() => {
                    this.$notify.error('duplication.parent_user.error');
                    this.inProgress = false;
                });
        },
        getParentUserForKindergartenSource(kindergarten) {
            if (this.selection.kindergartenTarget !== null) {
                if (this.selection.kindergartenTarget.id === kindergarten.id) {
                    this.targetParentUsers = [];
                }
            }
            if (kindergarten === null) {
                this.sourceParentUser = [];
            } else {
                this.showLoading = true;
                ParentUserRepository.findAllByKindergarten(kindergarten.id)
                    .then((parentUser) => {
                        this.sourceParentUser = parentUser;
                        this.showLoading = false;
                    })
                    .catch(() => {
                        this.$notify.error('duplication.parent_user.source.error');
                        this.showLoading = false;
                    });
            }
        },
        getParentUserForKindergartenTarget(kindergarten) {
            if (kindergarten === null) {
                this.targetParentUsers = [];
            } else {
                this.inProgress = true;
                ParentUserRepository.findAllByKindergarten(kindergarten.id)
                    .then((parentUser) => {
                        this.targetParentUsers = parentUser;
                        this.inProgress = false;
                    })
                    .catch(() => {
                        this.$notify.error('duplication.parent_user.source.error');
                        this.inProgress = false;
                    });
            }
        },

    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .column_status {
    width: 1px;
}
</style>
